// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'XS' | 'S' | 'M' | 'L' | 'XL' | number, // NOTE: イレギュラーサイズはそのまま数値を渡すようにする
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
/** @deprecated src/components/iconに定義されている新しいアイコンに置き換えます。
 *
 * 特段の理由がない場合、新規実装でこちらは使用しないでください。 */
const SvgExpand2 = ({ size = 'S', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'XS'
        ? '8px'
        : size === 'S'
        ? '16px'
        : size === 'M'
        ? '24px'
        : size === 'L'
        ? '32px'
        : size === 'XL'
        ? '40px'
        : size
    }
    height={
      size === 'XS'
        ? '8px'
        : size === 'S'
        ? '16px'
        : size === 'M'
        ? '24px'
        : size === 'L'
        ? '32px'
        : size === 'XL'
        ? '40px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <circle
      cx={8}
      cy={7.75}
      r={1.75}
      fill={props.color ?? 'currentColor'}
      transform="rotate(90 8 7.75)"
    />
    <circle
      cx={1.75}
      cy={7.75}
      r={1.75}
      fill={props.color ?? 'currentColor'}
      transform="rotate(90 1.75 7.75)"
    />
    <circle
      cx={14.25}
      cy={7.75}
      r={1.75}
      fill={props.color ?? 'currentColor'}
      transform="rotate(90 14.25 7.75)"
    />
  </svg>
)
export default SvgExpand2
